"use client";
import { registerStoryblokBridge as d } from "./storyblok-js.mjs";
import { useEffect as l, startTransition as o } from "react";
import { liveEditUpdateAction as r } from "./live-edit-update-action.mjs";
const m = ({ story: n = null, bridgeOptions: i = {} }) => {
  if (typeof window > "u")
    return null;
  const t = (e) => {
    e && o(() => {
      r({ story: e, pathToRevalidate: window.location.pathname });
    });
  }, a = (n == null ? void 0 : n.internalId) ?? (n == null ? void 0 : n.id) ?? 0;
  return l(() => {
    d(a, (e) => t(e), i);
  }, []), null;
};
export {
  m as default
};
